module.exports = __webpack_public_path__ + "static/img/5.bf179bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/sp/5.png
// module id = OKTF
// module chunks = 0